module.exports = __webpack_public_path__ + "img/home.f9f53f59.svg";